<template>
  <div class="message-container">
    <h3 class="tab-title">批量消息</h3>
    
    <!-- 顶部工具栏 -->
    <div class="message-toolbar">
      <el-button-group style="display: none;">
        <el-button 
          :type="filterMessageType === 1 ? 'primary' : 'default'"
          @click="handleMessageTypeChange(1)"
        >
          收件箱
          <el-badge v-if="unreadCount > 0" :value="unreadCount" class="item" />
        </el-button>
    <!--    <el-button 
          :type="filterMessageType === 2 ? 'primary' : 'default'"
          @click="handleMessageTypeChange(2)"
        >
          发件箱
        </el-button>    -->
      </el-button-group>

      <!-- 搜索区域 - 使用下拉框选择时间范围 -->
      <div class="search-area">
        <!-- 关键词搜索 -->
        <el-input
          v-model="searchForm.keyword"
          placeholder="搜索标题、内容或发件人"
          style="width: 200px;"
          clearable
          @clear="handleSearch"
          @keyup.enter="handleSearch"
        >
        <template #prefix>
          <i class="el-icon-search"></i>
        </template>
        </el-input>
        
        <!-- 时间范围下拉选择 -->
        <el-select
          v-model="searchForm.timeRangeType"
          placeholder="时间范围"
          style="width: 120px;"
          @change="handleTimeRangeChange"
          clearable
        >
          <el-option label="最近1个月" value="lastMonth" />
          <el-option label="最近7天" value="lastWeek" />
          <el-option label="最近3个月" value="lastQuarter" />
          <el-option label="今年" value="thisYear" />
          <el-option label="自定义" value="custom" />
        </el-select>
        
        <!-- 自定义日期选择器（默认隐藏，选择自定义时显示） -->
        <el-date-picker
          v-if="searchForm.timeRangeType === 'custom'"
          v-model="searchForm.customDateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 240px;"
          :shortcuts="dateShortcuts"
          :disabled-date="disabledDate"
          @change="handleCustomDateChange"
          clearable
        />
        
        <!-- 搜索按钮 -->
        <el-button type="primary" @click="handleSearch">
          搜索
        </el-button>
        
        <!-- 重置按钮 -->
        <el-button @click="resetSearch">
          重置
        </el-button>
      </div>
    </div>
    
    <!-- 站内信列表 -->
    <div class="message-list">
      <el-table 
        :data="messages" 
        v-loading="loading"
        empty-text="暂无消息"
        style=" margin: 0 auto;"
      >
        <!--el-table-column type="selection" width="55" -->
        
        <el-table-column prop="title" label="标题" width="300">
          <template #default="{ row }">
            <div class="message-title">
              <span v-if="!row.is_read" class="unread-dot"></span>
              <span :class="row.is_read?'':'unread-title'">{{ row.title }}</span>
            </div>
          </template>
        </el-table-column>       

        <el-table-column prop="created_time" label="发送时间" width="150">
          <template #default="{ row }">
            {{ formatDateTime(row.created_time) }}
          </template>
        </el-table-column>
        
        <el-table-column prop="readTime" label="阅读时间" width="150">
          <template #default="{ row }">
            <span v-if="row.read_time">{{ formatDateTime(row.read_time) }}</span>
            <span v-else class="unread-text">未读</span>
          </template>
        </el-table-column>
        
        <el-table-column label="操作">
          <template #default="{ row }">
            <div class="action-buttons">
              <el-button 
                type="text" 
                size="small"
                @click="viewMessageDetail(row.id)"
              >
                查看
              </el-button>              
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination" v-if="total > 0">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { 
  getBatchMessagesByTenant, 
  //getUnreadCount,
  getMessageDetail,
  getMessagesByConversationId,
  //markAsRead,
  //batchMarkAsRead,
  //deleteMessage,
  //batchDeleteMessages,
  //sendMessage
} from '@/api/tenant/message'

export default {
  name: 'MessageList',
  components: {
  },
  data() {
    // 计算最近1个月的日期范围
    const getLastMonthRange = () => {
      const end = new Date()
      end.setHours(23, 59, 59, 999)
      const start = new Date()
      start.setMonth(start.getMonth() - 1)
      start.setHours(0, 0, 0, 0)
      return [start, end]
    }
    
    const lastMonthRange = getLastMonthRange()
    
    return {
      // 搜索表单 - 使用下拉框方式
      searchForm: {
        keyword: '',           // 关键词
        timeRangeType: 'lastMonth',  // 默认最近1个月
        customDateRange: null, // 自定义日期范围
        startTime: lastMonthRange[0].getTime(),
        endTime: lastMonthRange[1].getTime()
      },     
      messages: [],
      loading: false,      
      // 筛选条件
      filterMessageType: 1,      
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,
      
      // 选中项
      selectedMessages: [],
      
      // 未读数量
      unreadCount: 0,
      
      // 排序
      sortField: 'created_time',
      sortOrder: 'desc',
      
      // 回复相关
      replyForm: {
        recipient: '',
        title: '',
        content: ''
      },
      currentOriginalMessage: null,
      
      // 用于记录当前正在回复的消息
      replyingMessageId: null,
      
      // 日期快捷选项
      dateShortcuts: [
        {
          text: '最近1个月',
          value: () => {
            const end = new Date()
            end.setHours(23, 59, 59, 999)
            const start = new Date()
            start.setMonth(start.getMonth() - 1)
            start.setHours(0, 0, 0, 0)
            return [start, end]
          }
        },
        {
          text: '最近7天',
          value: () => {
            const end = new Date()
            end.setHours(23, 59, 59, 999)
            const start = new Date()
            start.setDate(start.getDate() - 7)
            start.setHours(0, 0, 0, 0)
            return [start, end]
          }
        },
        {
          text: '最近3个月',
          value: () => {
            const end = new Date()
            end.setHours(23, 59, 59, 999)
            const start = new Date()
            start.setMonth(start.getMonth() - 3)
            start.setHours(0, 0, 0, 0)
            return [start, end]
          }
        }
      ]
    }
  },
  mounted() {
    this.loadMessages()
    //this.loadUnreadCount()
  },
  methods: {
      /**
       * 加载会话详情（获取同一会话的所有消息）
       */
      async loadConversationDetail(conversationId, originalMessage) {
        if (!conversationId) {
          this.$message.error('无法获取会话信息')
          return
        }
        
        this.detailLoading = true
        
        try {
          // 调用获取会话详情的接口（需要后端支持）
          const response = await getMessagesByConversationId(conversationId)
          console.log('会话详情:', response)
          
          if (response.data.code === 200 && response.data.data) {
            // 按时间排序
            const allMessages = response.data.data.sort((a, b) => 
              new Date(a.created_time) - new Date(b.created_time)
            )
            
            // 第一条是原始消息
            const originalMsg = allMessages[0]
            // 其余是回复
            const replies = allMessages.slice(1)
            
            // 显示会话详情弹窗
            this.showConversationDialog(originalMsg, replies)
          } else {
            // 如果接口失败，降级显示单条消息
            this.showMessageDialog(originalMessage)
          }
        } catch (error) {
          console.error('获取会话详情失败:', error)
          // 降级显示单条消息
          this.showMessageDialog(originalMessage)
        } finally {
          this.detailLoading = false
        }
      },

      /**
       * 显示会话详情弹窗
       */
      showConversationDialog(originalMsg, replies) {
        console.log("showConversationDialog", originalMsg, replies)
        const h = this.$createElement
        
        // 构建会话内容
        const content = h('div', { class: 'conversation-container' }, [
          // 原始消息
          h('div', { class: 'original-message' }, [
            h('div', { class: 'message-header' }, [
              h('span', { class: 'sender' }, originalMsg.sender_username || '系统'),
              h('span', { class: 'time' }, this.formatDateTime(originalMsg.created_time))
            ]),
            h('div', { class: 'message-title' }, originalMsg.title),
            h('div', { class: 'message-content' }, originalMsg.content)
          ]),
          
          // 回复列表
          ...replies.map(reply => 
            h('div', { class: 'reply-item' }, [
              h('div', { class: 'reply-header' }, [
                h('span', { class: 'sender' }, reply.sender_username || '系统'),
                h('span', { class: 'time' }, this.formatDateTime(reply.created_time)),
                h('el-tag', { props: { size: 'mini', type: 'success' } }, '回复')
              ]),
              h('div', { class: 'reply-content' }, reply.content)
            ])
          )
        ])
        
        this.$msgbox({
          title: '会话详情',
          message: content,
          confirmButtonText: '关闭',
          showCancelButton: false,
          customClass: 'conversation-dialog'
        })
      },    
    // 统一的时间格式化方法
    formatDateTime(dateTime) {
      if (!dateTime) return '-'
      
      // 补零函数
      const pad = (n) => (n !== undefined && n !== null) ? n.toString().padStart(2, '0') : '00'
      
      // 处理数组格式 [year, month, day, hour, minute, second]
      if (Array.isArray(dateTime)) {
        try {
          const year = dateTime[0]
          const month = pad(dateTime[1])
          const day = pad(dateTime[2])
          const hour = pad(dateTime[3] || 0)
          const minute = pad(dateTime[4] || 0)
          const second = pad(dateTime[5] || 0)
          
          return `${year}-${month}-${day} ${hour}:${minute}:${second}`
        } catch (e) {
          console.error('日期格式化错误:', e, dateTime)
          return String(dateTime)
        }
      }
      
      // 处理字符串或时间戳
      try {
        const date = new Date(dateTime)
        if (isNaN(date.getTime())) return String(dateTime)
        
        const year = date.getFullYear()
        const month = pad(date.getMonth() + 1)
        const day = pad(date.getDate())
        const hour = pad(date.getHours())
        const minute = pad(date.getMinutes())
        const second = pad(date.getSeconds())
        
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`
      } catch (e) {
        return String(dateTime)
      }
    },
    /**
     * 处理搜索
     */
    handleSearch() {
      console.log('执行搜索:', this.searchForm)
      this.currentPage = 1  // 重置到第一页
      this.loadMessages()
    },
    
    /**
     * 重置搜索条件 - 重置到最近1个月
     */
    resetSearch() {
      const lastMonthRange = (() => {
        const end = new Date()
        end.setHours(23, 59, 59, 999)
        const start = new Date()
        start.setMonth(start.getMonth() - 1)
        start.setHours(0, 0, 0, 0)
        return [start, end]
      })()   
      this.searchForm = {
        keyword: '',
        timeRangeType: 'lastMonth',
        customDateRange: null,
        startTime: lastMonthRange[0].getTime(),
        endTime: lastMonthRange[1].getTime()
      }
      this.currentPage = 1
      this.loadMessages()
      this.$message.success('已重置为最近1个月的消息')
    },

    /**
     * 时间范围选择变化
     */
    handleTimeRangeChange(value) {
      if (!value) {
        // 清空选择，默认最近1个月
        this.setLastMonthRange()
        return
      }
      
      if (value === 'custom') {
        // 选择自定义，清空时间戳，等待用户选择日期
        this.searchForm.customDateRange = null
        this.searchForm.startTime = null
        this.searchForm.endTime = null
        return
      }
      
      // 根据选择设置时间范围
      const now = new Date()
      const end = new Date()
      end.setHours(23, 59, 59, 999)
      let start = new Date()
      
      switch (value) {
        case 'lastMonth':
          start.setMonth(start.getMonth() - 1)
          break
        case 'lastWeek':
          start.setDate(start.getDate() - 7)
          break
        case 'lastQuarter':
          start.setMonth(start.getMonth() - 3)
          break
        case 'thisYear':
          start = new Date(now.getFullYear(), 0, 1)
          start.setHours(0, 0, 0, 0)
          break
      }
      
      start.setHours(0, 0, 0, 0)
      
      this.searchForm.startTime = start.getTime()
      this.searchForm.endTime = end.getTime()
      
      // 自动搜索
      this.handleSearch()
    },

    /**
     * 自定义日期范围变化
     */
    handleCustomDateChange(dates) {
      if (dates && dates.length === 2) {
        const startDate = new Date(dates[0])
        startDate.setHours(0, 0, 0, 0)
        const endDate = new Date(dates[1])
        endDate.setHours(23, 59, 59, 999)
        
        this.searchForm.startTime = startDate.getTime()
        this.searchForm.endTime = endDate.getTime()
        this.handleSearch()
      }
    },

    /**
     * 设置最近1个月
     */
    setLastMonthRange() {
      const end = new Date()
      end.setHours(23, 59, 59, 999)
      const start = new Date()
      start.setMonth(start.getMonth() - 1)
      start.setHours(0, 0, 0, 0)
      
      this.searchForm.timeRangeType = 'lastMonth'
      this.searchForm.startTime = start.getTime()
      this.searchForm.endTime = end.getTime()
      this.searchForm.customDateRange = null
    },
    
    /**
     * 处理消息类型切换
     */
    handleMessageTypeChange(type) {
      this.filterMessageType = type
      this.currentPage = 1
      this.selectedMessages = []
      this.loadMessages()
      if (type === 1) {
        this.loadUnreadCount()
      }
    },
    
    /**
     * 处理排序变化
     */
    handleSortChange({ prop, order }) {
      this.sortField = prop || 'created_time'
      this.sortOrder = order === 'ascending' ? 'asc' : 'desc'
      this.loadMessages()
    },
    
    /**
     * 加载消息列表（支持搜索）
     */
    async loadMessages() {
      this.loading = true;
      try {
        const params = {
          page: this.currentPage,
          size: 100,
          messageType: this.filterMessageType,
          startTime: this.searchForm.startTime,
          endTime: this.searchForm.endTime
        };
        console.log("loadMessages params:", params);
        
        const response = await getBatchMessagesByTenant(params);
        console.log("API响应:", response);
        
        if (response.code === 200 && response.data) {
          // 根据实际返回的数据结构调整
          if (response.data.content) {
            // 如果返回的是 Page 对象
            this.messages = response.data.content || [];
            this.total = response.data.totalElements || 0;
          } else if (response.data.data) {
            // 如果返回的是 PageResult 对象
            this.messages = response.data.data || [];
            this.total = response.data.total || 0;
          } else if (Array.isArray(response.data)) {
            // 如果直接返回数组
            this.messages = response.data;
            this.total = this.messages.length;
          } else {
            // 其他情况
            this.messages = [];
            this.total = 0;
          }
          
          console.log("处理后的消息列表:", this.messages);
          console.log("总记录数:", this.total);
        }
      } catch (error) {
        console.error('加载消息失败:', error);
        this.$message.error('加载消息失败');
      } finally {
        this.loading = false;
      }
    },
    
// 查看消息详情并自动标记已读
async viewMessageDetail(id) {
    //console.log('查看消息详情:', message)
  let response = await getMessageDetail(id);
  console.log('查看消息详情:', response)
  let message= response.data
  
  // 简化版本：直接显示单条消息，忽略会话功能
  if(response.code==200)
    this.showMessageDialog(message)
},
    
  // 显示消息详情弹框
  showMessageDialog(detail) {
    const h = this.$createElement
    
    // 检查是否包含原文分隔符
    const hasOriginal = detail.content && detail.content.includes('====================')
    
    let contentDisplay
    
    if (hasOriginal) {
      const parts = detail.content.split('====================')
      const replyPart = parts[0].replace('【回复】', '').trim()
      const originalPart = parts[1]?.replace('【原文】', '').trim() || ''
      
      contentDisplay = h('div', {}, [
        // 回复内容
        h('div', {
          style: {
            marginBottom: '30px',
            padding: '15px',
            backgroundColor: '#f0f9eb',
            borderRadius: '4px'
          }
        }, [
          h('div', {
            style: {
              fontSize: '14px',
              fontWeight: '500',
              color: '#67c23a',
              marginBottom: '10px',
              display: 'flex',
              alignItems: 'center'
            }
          }, [
            h('span', {
              style: {
                marginRight: '8px'
              }
            }, '📤 回复内容'),
          ]),
          h('div', {
            style: {
              whiteSpace: 'pre-wrap',
              lineHeight: '1.6',
              color: '#333'
            }
          }, replyPart)
        ]),
        
        // 原文
        h('div', {
          style: {
            padding: '15px',
            backgroundColor: '#f5f7fa',
            borderRadius: '4px'
          }
        }, [
          h('div', {
            style: {
              fontSize: '14px',
              fontWeight: '500',
              color: '#909399',
              marginBottom: '10px',
              display: 'flex',
              alignItems: 'center'
            }
          }, [
            h('span', {
              style: {
                marginRight: '8px'
              }
            }, '📥 原文'),
          ]),
          h('div', {
            style: {
              whiteSpace: 'pre-wrap',
              lineHeight: '1.6',
              color: '#666'
            }
          }, originalPart)
        ])
      ])
    } else {
      // 如果没有原文分隔符，直接显示内容
      // 修改这里以支持HTML内容渲染
      contentDisplay = h('div', {
        style: {
          whiteSpace: 'pre-wrap',
          lineHeight: '1.6',
          color: '#333'
        },
        domProps: {
          innerHTML: detail.content || '无内容'
        }
      })
    }
    
    // 创建消息内容容器
    const messageContent = h('div', {
      style: {
        maxHeight: '60vh',
        overflowY: 'auto',
        padding: '15px',
        backgroundColor: '#fff',
        borderRadius: '4px'
      },
      class: 'message-detail-content'
    }, [
      // 消息头部信息
      h('div', {
        style: {
          marginBottom: '20px',
          paddingBottom: '15px',
          borderBottom: '1px solid #ebeef5'
        }
      }, [
        h('h3', {
          style: {
            margin: '0 0 15px 0',
            fontSize: '18px',
            fontWeight: '600',
            color: '#303133',
            lineHeight: '1.4',
            wordBreak: 'break-word'
          }
        }, detail.title || '消息详情'),
        
        h('div', {
          style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '15px',
            fontSize: '13px',
            color: '#666'
          }
        }, [
          h('div', [
            h('span', { style: { fontWeight: '500', color: '#909399' } }, '发件人：'),
            detail.sender_username || '系统'
          ]),
          
          h('div', [
            h('span', { style: { fontWeight: '500', color: '#909399' } }, '发送时间：'),
            this.formatDateTime(detail.created_time)
          ]),
          
          detail.readTime && h('div', [
            h('span', { style: { fontWeight: '500', color: '#909399' } }, '阅读时间：'),
            this.formatDateTime(detail.read_time)
          ])
        ].filter(Boolean))
      ]),
      
      // 消息正文内容
      contentDisplay
    ])
    
    // 创建弹框内容容器
    const dialogContent = h('div', {
      style: {
        maxHeight: '70vh',
        display: 'flex',
        flexDirection: 'column'
      }
    }, [
      messageContent
    ])
    
    this.$msgbox({
      title: '消息详情',
      message: dialogContent,
      confirmButtonText: '关闭',
      showCancelButton: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      showClose: true,
      customClass: 'message-detail-dialog',
      customStyle: {
        maxWidth: '2400px',
        width: '100%',
        maxHeight: '85vh',   // 增加最大高度，如从默认值改为85vh
        height: 'auto'       // 或设置具体高度
      },
      beforeClose: (action, instance, done) => {
        this.loadMessages()
        done()
      }
    }).then(() => {
      console.log('消息详情弹框关闭')
    }).catch(() => {
      this.loadMessages()
    })
  }
 }
}
</script>

<style scoped>
.message-container {
  padding: 20px;
}

.message-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.message-title {
  display: block;
  align-items: center;
  margin-left: 10px;
  padding-left: 5px;
}

.unread-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #f56c6c;
  border-radius: 50%;
  margin-right: 8px;
}

.unread-title {
  font-weight: bold;
}

.message-content {
  color: #606266;
  padding: 0 5px 0 5px;
  margin: 0 5px ;
}

.unread-text {
  display: block;
  color: #f56c6c;
   width:100%; 
   text-align: center;
}

.action-buttons {
  display: block;
  width:100%;
  text-align:center;
}

.reply-btn {
  color: #67c23a;
}

.delete-btn {
  color: #f56c6c;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>

<style>
/* 自定义弹框样式 */
.message-detail-dialog,
.reply-message-dialog {
  width: 90% !important;
  max-width: 120vw !important;
}
.reply-message-dialog .el-message-box {
  width: 100% !important;
  max-height: 70vh !important;
  display: flex;
  flex-direction: column;
}
.message-detail-dialog .el-message-box__content,
.reply-message-dialog .el-message-box__content {
  padding: 20px !important;
  max-height: calc(70vh - 120px);
  overflow-y: auto;
}

.message-detail-dialog .el-message-box__header,
.reply-message-dialog .el-message-box__header {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
  flex-shrink: 0;
}

.message-detail-dialog .el-message-box__title,
.reply-message-dialog .el-message-box__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.message-detail-dialog .el-message-box__message,
.reply-message-dialog .el-message-box__message {
  padding: 0 !important;
  width: 100%;
}

.message-detail-dialog .el-message-box__btns,
.reply-message-dialog .el-message-box__btns {
  padding: 16px 24px;
  border-top: 1px solid #ebeef5;
  flex-shrink: 0;
}
.reply-message-dialog .el-message-box__btns button {
  min-width: 80px;
}
/* 确保弹框显示在最上层 */
.el-overlay {
  z-index: 9999 !important;
}

/* 回复对话框表单样式 */
.reply-message-dialog .el-form-item {
  margin-bottom: 16px;
}

.reply-message-dialog .el-input__inner,
.reply-message-dialog .el-textarea__inner {
  min-height: 180px;
  resize: vertical;
}
.reply-message-dialog .el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  color: #909399;
}
/* 滚动条样式 */
.reply-message-dialog .el-message-box__content::-webkit-scrollbar {
  width: 6px;
}

.reply-message-dialog .el-message-box__content::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}

.reply-message-dialog .el-message-box__content::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

.reply-message-dialog .el-message-box__content::-webkit-scrollbar-thumb:hover {
  background: #a8abb2;
}

/* 确保弹框显示在最上层 */
.el-overlay {
  z-index: 9999 !important;
}

/* 消息详情弹框样式保持不变 */
.message-detail-dialog {
  margin-top: 50px;
  max-width: 700px;
}

.message-detail-dialog .el-message-box__content {
  padding: 0;
}

.message-detail-dialog .el-message-box__header {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}

.message-detail-dialog .el-message-box__title {
  font-size: 18px;
  font-weight: 600;
}

.message-detail-dialog .el-message-box__message {
  padding: 0;
}

.message-detail-dialog .el-message-box__btns {
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
}
/* 原生输入框的聚焦样式 */
.reply-message-dialog input:focus,
.reply-message-dialog textarea:focus {
  border-color: #409eff !important;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

/* 输入框悬停效果 */
.reply-message-dialog input:hover,
.reply-message-dialog textarea:hover {
  border-color: #c0c4cc;
}

/* 确保弹框显示在最上层 */
.el-overlay {
  z-index: 9999 !important;
}

/* 消息详情弹框样式保持不变 */
.message-detail-dialog {
  max-width: 700px;
}

.message-detail-dialog .el-message-box__content {
  padding: 0;
}

.message-detail-dialog .el-message-box__header {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}

.message-detail-dialog .el-message-box__title {
  font-size: 18px;
  font-weight: 600;
}

.message-detail-dialog .el-message-box__message {
  padding: 0;
}

.conversation-container {
  max-height: 60vh;
  overflow-y: auto;
  padding: 10px;
}

.original-message {
  background: #f0f7ff;
  border-left: 4px solid #409EFF;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 20px;
}

.reply-item {
  background: #f5f5f5;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 15px;
  margin-left: 20px;
}

.message-header, .reply-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 13px;
}

.sender {
  font-weight: 600;
  margin-right: 10px;
  color: #409EFF;
}

.time {
  color: #999;
  font-size: 12px;
}

.message-title {
  font-weight: bold;
  margin-bottom: 8px;
}

.message-content, .reply-content {
  white-space: pre-wrap;
  line-height: 1.6;
  color: #333;
}
.conversation-history {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.4;
}

.conversation-history .history-content {
  margin: 4px 0;
  padding: 0;
}
</style>